import React from 'react';
import TeamDetailsFact from '../../../../components/TeamDetailsFact/TeamDetailsFact';

const TeamDetailsFacts = () => {
  return (
    <>
      <section className="tp-fact-area pb-65">
        <div className="container">
          <div className="row">
            <TeamDetailsFact icon_name="shuttle" fact_number="2025" fact_name="Projet terminé"></TeamDetailsFact>
            <TeamDetailsFact icon_name="broom" fact_number="3050" fact_name="Nettoyeur dédié"></TeamDetailsFact>
            <TeamDetailsFact icon_name="selection" fact_number="8205" fact_name="Client satisfait"></TeamDetailsFact>
            <TeamDetailsFact icon_name="badge" fact_number="56" fact_name="Prix local"></TeamDetailsFact>
          </div>
        </div>
      </section>
    </>
  );
};

export default TeamDetailsFacts;